function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import warning from 'warning';
import { Select, Input, AutoComplete, Icon } from 'mkui-fd';
import noop from '../_util/noop';
import { isEmpty } from '../_util/stringUtils';
import { getCategory } from './util';
import TYPE from './constants';
var Option = Select.Option;
var Search = Input.Search;
var AutoCompleteOption = AutoComplete.Option;

var MultipleSearch = /*#__PURE__*/function (_React$Component) {
  _inherits(MultipleSearch, _React$Component);

  /** *******************static************************** */

  /** *******************life cycle************************** */
  function MultipleSearch(props) {
    var _this;

    _classCallCheck(this, MultipleSearch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultipleSearch).call(this, props));
    _this.state = {
      categoryCode: '',
      data: []
    };
    return _this;
  }
  /** *******************handle************************** */


  _createClass(MultipleSearch, [{
    key: "categorySelectHandle",
    value: function categorySelectHandle(value) {
      this.setState({
        categoryCode: value
      });
      this.fireChange('');
    }
  }, {
    key: "onDataFetchHandle",
    value: function onDataFetchHandle(value) {
      var _this2 = this;

      var onDataFetch = this.props.onDataFetch;
      onDataFetch({
        field: this.getSelectedCategoryCode(),
        keyword: value.trim()
      }).then(function (data) {
        _this2.setState({
          data: data
        });
      });
    }
  }, {
    key: "inputSearchHandle",
    value: function inputSearchHandle(value) {
      var onSearch = this.props.onSearch;
      value = value.trim();
      onSearch({
        field: this.getSelectedCategoryCode(),
        value: value,
        text: value
      });
    }
  }, {
    key: "inputChangeHandle",
    value: function inputChangeHandle(e) {
      var value = e.target.value;
      this.fireChange(value.trim());
    }
  }, {
    key: "autoCompleteChangeHandle",
    value: function autoCompleteChangeHandle(value) {
      this.fireChange(value.trim());
    }
  }, {
    key: "autoCompleteSelectHandle",
    value: function autoCompleteSelectHandle(value, option) {
      var onSearch = this.props.onSearch;
      var text = option.props.children;
      onSearch({
        field: this.getSelectedCategoryCode(),
        value: value.trim(),
        text: text
      });
    }
    /** *******************inner method************************** */

  }, {
    key: "getSelectedCategoryCode",
    value: function getSelectedCategoryCode() {
      var options = this.props.options;
      var categoryCode = this.state.categoryCode;
      warning(!options || options.length, 'attribute of options is excepted for Multiple Search but find undefind');
      return isEmpty(categoryCode) ? options[0].dataField : categoryCode;
    }
  }, {
    key: "fireChange",
    value: function fireChange(value) {
      var onChange = this.props.onChange;
      onChange(value);
    }
    /** *******************render method************************** */

  }, {
    key: "renderSelect",
    value: function renderSelect() {
      var _this3 = this;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          options = _this$props.options;
      var selectedCategory = getCategory(options, this.getSelectedCategoryCode());
      return React.createElement("div", {
        className: "".concat(prefixCls, "-dropdown")
      }, React.createElement(Select, {
        value: selectedCategory.dataField,
        onChange: function onChange(value) {
          _this3.categorySelectHandle(value);
        }
      }, options.map(function (item) {
        return React.createElement(Option, {
          key: item.dataField,
          value: item.dataField
        }, item.name);
      })));
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this4 = this;

      var data = this.state.data;
      var _this$props2 = this.props,
          value = _this$props2.value,
          options = _this$props2.options;
      var selectedCategory = getCategory(options, this.getSelectedCategoryCode());

      if (selectedCategory.type === TYPE.SEARCH) {
        return React.createElement(Search, {
          placeholder: selectedCategory.placeholder,
          value: value,
          onPressEnter: function onPressEnter(e) {
            return _this4.inputSearchHandle(e.target.value);
          },
          onChange: function onChange(e) {
            return _this4.inputChangeHandle(e);
          }
        });
      } else if (selectedCategory.type === TYPE.AUTO_COMPLETE) {
        return React.createElement(AutoComplete, {
          placeholder: selectedCategory.placeholder,
          value: value,
          onChange: function onChange(v) {
            return _this4.autoCompleteChangeHandle(v);
          },
          onSearch: function onSearch(v) {
            return _this4.onDataFetchHandle(v);
          },
          onSelect: function onSelect(v, option) {
            return _this4.autoCompleteSelectHandle(v, option);
          },
          dataSource: data.map(function (item) {
            return React.createElement(AutoCompleteOption, {
              key: item.code,
              value: item.code
            }, item.name);
          })
        }, React.createElement(Input, {
          suffix: React.createElement(Icon, {
            type: "search"
          })
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var prefixCls = this.props.prefixCls;
      return React.createElement("div", {
        className: "".concat(prefixCls)
      }, this.renderSelect(), React.createElement("div", {
        className: "".concat(prefixCls, "-input")
      }, this.renderInput()));
    }
  }]);

  return MultipleSearch;
}(React.Component);

_defineProperty(MultipleSearch, "propTypes", {
  options: PropTypes.array,
  onSearch: PropTypes.func,
  onDataFetch: PropTypes.func,
  onChange: PropTypes.func,
  prefixCls: PropTypes.string,
  value: PropTypes.string
});

_defineProperty(MultipleSearch, "defaultProps", {
  prefixCls: 'mkui-multiple-search',
  options: [],
  onSearch: noop,
  onDataFetch: noop,
  onChange: noop,
  value: ''
});

export { MultipleSearch as default };
//# sourceMappingURL=MultipleSearch.js.map
